import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "lib-full-screen-loading",
  templateUrl: "./full-screen-loading.component.html",
  styleUrls: ["./full-screen-loading.component.scss"],
  standalone: false,
})
export class FullScreenLoadingComponent implements OnInit {
  public loadingSpinner = new Array(12);

  @Input() isShown: boolean;

  ngOnInit() {}
}
